// tslint:disable
export enum NoteAggregateGroupBy {
    /**
     * @description Empty option
     */
    None = 0,
    /**
     * @description Task type
     */
    TaskType = 1,
    /**
     * @description Task source (e.g Case or Account)
     */
    TaskSource = 2,
}
(NoteAggregateGroupBy as any)['NONE'] = 0;
(NoteAggregateGroupBy as any)['TASKTYPE'] = 1;
(NoteAggregateGroupBy as any)['TASKSOURCE'] = 2;
